<template>
  <div class="login">
    <div class="Land">
      <div class="topzi">信息管理系统</div>
      <div class="login-box">
        <input type="text" v-model="ruleForm.account" class="ipt" placeholder="请输入账号" />
        <input type="password" v-model="ruleForm.password" class="ipt" placeholder="请输入密码" />
        <el-button class="loginBtn" type="primary" @click="submitForm('ruleForm')">登录</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import md5 from "js-md5";
export default {
  data() {
    return {
      ruleForm: {
        account: "",
        password: "",
      },
    };
  },
  created() { },
  methods: {
    submitForm(formName) {
      if (!this.ruleForm.account) {
        this.$notify.error({
          title: "提示",
          message: "请输入账号",
        });
        return;
      }
      if (!this.ruleForm.password) {
        this.$notify.error({
          title: "提示",
          message: "请输入密码",
        });
        return;
      }
      let loginData = {
        ...this.ruleForm,
        password: md5(this.ruleForm.password.toString()),
      };

      this.$axios({
        url: '/login',
        method: 'get',
        params: {
          account: this.ruleForm.account,
          password: this.ruleForm.password
        },
      }).then(res => {
        let resp = res.data;

        if (resp.code != 200) {
          this.$notify.error({
            title: "提示",
            message: "用户名或密码错误",
          });
        } else {
          this.$notify.success({
            title: "提示",
            message: "登录成功",
          });
          localStorage.setItem('user', JSON.stringify(res.data))
          this.$router.replace("user");
        }
      })
      
    },
  },
};
</script>
<style lang="less">
.login {
  position: relative;
  width: 100%;
  height: 100%;
  background: url("../../assets/login.png") no-repeat center / 100% 100%;
}

.copyRight {
  position: absolute;
  width: 100%;
  bottom: 10px;
  text-align: center;

  a {
    font-size: 12px;
    color: #f0f0f0;
    text-decoration: unset;
  }
}

.Land {
  width: 494px;
  height: 337px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  // border: 1px solid #e5e5e5;
  // padding: 15px;
  // box-shadow:1px 2px 3px #352e2e ;
  border-radius: 4px;
  background: #fff;

  .topzi {
    text-align: center;
    font-size: 20px;
    color: #fff;
    background: #4a4a90;
    height: 60px;
    line-height: 60px;
  }

  .login-box {
    padding-top: 35px;

    .ipt {
      display: block;
      width: 345px;
      height: 50px;
      margin: 0 auto;
      background: #e9edf0;
      text-align: center;
      font-size: 18px;

      &:nth-child(2) {
        margin-top: 25px;
      }
    }
  }

  .loginBtn {
    width: 345px;
    font-size: 18px;
    display: block;
    margin: 0 auto;
    margin-top: 32px;
  }
}
</style>
